import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  DocumentResponse,
  DocumentsApiService,
  DocumentsListParams,
} from 'features/document-report/api/documents-api.service';
import { RoleListParams } from 'features/role-management/api/role-api.service';
import qs from 'qs';

import { DocumentQueryKeys } from './query-keys';
const { dropDownByClassFlag } = DocumentsApiService();

const getUsersQuery = (
  params: RoleListParams,
  options?: UseQueryOptions<DocumentResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<any>;
  options?: UseQueryOptions<DocumentResponse>;
} => ({
  queryKey: DocumentQueryKeys.list(params),
  queryFn: ({ signal }) =>
    dropDownByClassFlag(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetDropDownList = (
  params: DocumentsListParams,
  options?: UseQueryOptions<DocumentResponse>,
) => {
  const { message } = App.useApp();

  return useQuery<DocumentResponse, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
